/**
 * Stage Slider Component
 * Handles multi-stage slider functionality with autoplay and thumbnails
 */
document.addEventListener('DOMContentLoaded', function () {
	const stageContainers = document.querySelectorAll('[data-stage-id^="stage-"]')
	const stageGroups = {}

	// Group stage containers by their base ID
	stageContainers.forEach(container => {
		const stageId = container.getAttribute('data-stage-id')
		const baseId = stageId.replace('-upper', '').replace('-lower', '')

		if (!stageGroups[baseId]) {
			stageGroups[baseId] = {
				main: null,
				upper: null,
				lower: null,
			}
		}

		if (stageId.includes('-upper')) {
			stageGroups[baseId].upper = container
		} else if (stageId.includes('-lower')) {
			stageGroups[baseId].lower = container
		} else {
			stageGroups[baseId].main = container
		}
	})

	// Initialize each stage group
	Object.keys(stageGroups).forEach(stageId => {
		const group = stageGroups[stageId]
		const mainSlider = group.main
		const upperThumb = group.upper
		const lowerThumb = group.lower

		if (!mainSlider) return

		const mainWrapper = mainSlider.querySelector('.flex')
		const upperWrapper = upperThumb?.querySelector('.flex')
		const lowerWrapper = lowerThumb?.querySelector('.flex')
		const bullets = mainSlider.querySelectorAll('button[data-slide]')
		const slideCount = bullets.length

		if (slideCount === 0) return

		let currentSlide = 0
		let autoplayInterval

		/**
		 * Updates slider position and bullet states
		 * @param {number} index - Target slide index
		 */
		function updateSlider(index) {
			currentSlide = index

			// Update main slider
			if (mainWrapper) {
				mainWrapper.style.transform = `translateX(-${index * 100}%)`
			}

			// Update upper thumbnail (next slide)
			if (upperWrapper && slideCount > 1) {
				const upperIndex = (index + 1) % slideCount
				upperWrapper.style.transform = `translateX(-${upperIndex * 100}%)`
			}

			// Update lower thumbnail (slide after next)
			if (lowerWrapper && slideCount > 2) {
				const lowerIndex = (index + 2) % slideCount
				lowerWrapper.style.transform = `translateX(-${lowerIndex * 100}%)`
			}

			// Update bullet states
			bullets.forEach((bullet, i) => {
				bullet.classList.remove('opacity-100', 'scale-110')
				bullet.classList.add('opacity-70')
				if (i === index) {
					bullet.classList.remove('opacity-70')
					bullet.classList.add('opacity-100', 'scale-110')
				}
			})
		}

		/**
		 * Starts autoplay functionality
		 */
		function startAutoplay() {
			if (slideCount <= 1) return
			autoplayInterval = setInterval(() => {
				const newIndex = currentSlide < slideCount - 1 ? currentSlide + 1 : 0
				updateSlider(newIndex)
			}, 5000) // 5 second intervals
		}

		/**
		 * Resets autoplay timer
		 */
		function resetAutoplay() {
			clearInterval(autoplayInterval)
			startAutoplay()
		}

		// Add click handlers to bullets
		bullets.forEach((bullet, index) => {
			bullet.addEventListener('click', () => {
				updateSlider(index)
				resetAutoplay()
			})
		})

		// Pause autoplay on hover
		mainSlider.addEventListener('mouseenter', () => {
			clearInterval(autoplayInterval)
		})

		// Resume autoplay when not hovering
		mainSlider.addEventListener('mouseleave', () => {
			startAutoplay()
		})

		// Initialize slider
		updateSlider(0)
		startAutoplay()
	})
})
